import {connect} from 'react-redux';
import classnames from 'classnames';
import ReactModal from 'react-modal';
import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';

import Other from './Other';
import Photo from './Photo';
import Prices from './Prices';
import Address from './Address';
import Calendar from './CalendarTab';
import Layout from '../Base/Layout';
import OtherSell from './OtherSell';
import Amenities from './Amenities';
import ChannelManager from './ChannelManager';
import ChannelManagerAirbnb from './airbnbCm/ChannelManagerAirbnb';
import Characteristics from './Characteristics';
import * as RouteUtils from '../../utils/Route';
import GeneralInformation from './GeneralInformation';
import * as ObjectConst from '../../constants/Property';
import {
    getCreatedObject,
    stopRedirect,
    updateField,
    setRedirectToObjectPage,
    publishObject
} from '../../actions/CreatingObjectPage';

import cameraPNG from '../../static/img/new/camera.png';

const defaultProps = {
    stopRedirect: () => {
    },
    getCreatedObject: objectId => {
    },
    updateField: (objectId, updateFieldCommand) => {
    },
    setRedirectToObjectPage: isRedirectToObjectPage => {
    }
};

class CreateEditPropertyPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tabsSwitchIsActive: false,
            isShowNotValidModal: false,
            activeTab: 'generalInformation'
        }

        this.getPropertyId = this.getPropertyId.bind(this);
    }

    componentWillMount() {
        this.props.stopRedirect();
        this.props.getCreatedObject(this.getPropertyId())
            .catch((error) => {
                window.location = '/404';
            });

        let activeTab = window.location.search.split('activeTab=')[1]

        if (activeTab !== undefined) {
            this.setState({activeTab: activeTab})
        }
    }
    getPropertyId() {
        return this.props.match.params.id
    }

    handleTabClick(event) {
        event.preventDefault();

        this.setState({
            activeTab: event.target.dataset.name
        })
    }

    handleTabsSwitchClick(event) {
        event.preventDefault();

        this.setState(prevState => ({
            tabsSwitchIsActive: !prevState.tabsSwitchIsActive
        }));
    }

    handlePublishClick = event => {
        event.preventDefault();
        const {
            objectId,
            updateField,
            isPricesValid,
            isAddressValid,
            isGeneralInformationValid
        } = this.props;

        if (isGeneralInformationValid && isAddressValid && isPricesValid) {
            const updateFieldCommand = {
                name: ObjectConst.FIELDS.STATUS,
                value: ObjectConst.STATUS.ACTIVE
            };

            this.props.publishObject(objectId);
        } else {
            this.setState({
                isShowNotValidModal: true
            });
        }
    };

    handleHideNotValidModal() {
        this.setState({
            isShowNotValidModal: false
        })
    }

    render() {
        const {activeTab} = this.state;
        const {i18n, isPricesValid, isOtherValid, currentUser} = this.props;
        const propertyId = this.getPropertyId();

        if(currentUser.accessToken === undefined || currentUser.accessToken == null){
            return <Redirect to={RouteUtils.getPropertyPathname(this.props.objectId)}/>;
        }

        if (this.props.isRedirectToObjectPage) {
            this.props.setRedirectToObjectPage(false);

            return <Redirect to={RouteUtils.getPropertyPathname(this.props.objectId)}/>;
        } else {
            return (
                <Layout
                    title={i18n['creatingObjectPage.document.title'] !== undefined ? i18n['creatingObjectPage.document.title'] : ''}
                >
                    <div className="clearfix container">
                        <div className="clearfix white_box add_container">
                            <div className="clearfix heading">
                                <h2>
                                    {i18n['creatingObjectPage.creatingANewObject']}
                                </h2>
                            </div>

                            <div className="clearfix add_short_info mt20">
                                <div className="tablebox middle auto">
                                    <div>
                                        <a
                                            href=""
                                            className="clearfix z-photo"
                                            onClick={event => event.preventDefault()}
                                            style={{
                                                backgroundImage: `url(${this.props.mainPhotoURL.length > 0 ?
                                                    this.props.mainPhotoURL : cameraPNG})`
                                            }}
                                        >

                                        </a>
                                    </div>
                                    <div>
                                        <a href="" className="clearfix z-title"
                                           onClick={event => event.preventDefault()}>
                                            {this.props.displayName === undefined || this.props.displayName.length === 0 ?
                                                '---' : this.props.displayName}
                                        </a>
                                    </div>
                                    <div>
                                        <a
                                            target='_blank'
                                            className="clearfix button lg icon eye"
                                            href={RouteUtils.getPropertyPathname(this.props.objectId)}
                                        >
                                        <span>
                                            {i18n['creatingObjectPage.viewAd']}
                                        </span>
                                        </a>
                                    </div>
                                    <div className="add_save_button_top">
                                        <a
                                            href=""
                                            onClick={this.handlePublishClick}
                                            className="button lg icon check fullwidth add_save_button"
                                        >
                                            <span>
                                                {i18n['creatingObjectPage.publish']}
                                            </span>
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="tablebox top add_entry responsive">
                                <div className="clearfix add_nav">

                                    <div
                                        data-toggle-class="active"
                                        data-target="#primary_tabs"
                                        onClick={::this.handleTabsSwitchClick}
                                        className={this.state.tabsSwitchIsActive ?
                                            'tabs_switcher js_tab_switch tablebox middle active'
                                            :
                                            'tabs_switcher js_tab_switch tablebox middle'}
                                    >
                                        <div>
                                        <span>
                                            <i className="fa fa-chevron-circle-right"/>
                                        </span>
                                        </div>
                                    </div>

                                    <ul
                                        id="primary_tabs"
                                        data-target="#m-tab"
                                        className={this.state.tabsSwitchIsActive ?
                                            'clearfix tabs js_tab animated show active'
                                            :
                                            'clearfix tabs js_tab animated show'}
                                    >
                                        <li
                                            data-name='generalInformation'
                                            onClick={::this.handleTabClick}
                                            className={
                                                this.state.activeTab === 'generalInformation' ?
                                                    this.props.isGeneralInformationValid ? 'active' : 'active alert'
                                                    :
                                                    this.props.isGeneralInformationValid ? '' : 'alert'
                                            }
                                        >
                                            {i18n['creatingObjectPage.generalInformation']}
                                        </li>
                                        <li
                                            data-name='prices'
                                            onClick={::this.handleTabClick}
                                            className={classnames({
                                                'active': activeTab === 'prices',
                                                'alert': !isPricesValid
                                            })}
                                        >
                                            {i18n['creatingObjectPage.priceList']}, {this.props.currency}
                                        </li>
                                        <li
                                            data-name='address'
                                            onClick={::this.handleTabClick}
                                            className={
                                                this.state.activeTab === 'address' ?
                                                    this.props.isAddressValid ? 'active' : 'active alert'
                                                    :
                                                    this.props.isAddressValid ? '' : 'alert'
                                            }
                                        >
                                            {i18n['creatingObjectPage.address']}
                                        </li>
                                        {this.props.type === ObjectConst.TYPE.RENT && <li
                                            data-name='facilities'
                                            onClick={::this.handleTabClick}
                                            className={
                                                this.state.activeTab === 'facilities' ? 'active' : ''
                                            }
                                        >
                                            {i18n['creatingObjectPage.facilities']}
                                        </li>}
                                        {this.props.type === ObjectConst.TYPE.SELL && <li
                                            data-name='characteristics'
                                            onClick={::this.handleTabClick}
                                            className={classnames({
                                                'active': activeTab === 'characteristics'
                                            })}
                                        >
                                            {i18n['creatingObjectPage.characteristics']}
                                        </li>}
                                        {this.props.type === ObjectConst.TYPE.RENT && <li
                                            data-name='other'
                                            onClick={::this.handleTabClick}
                                            className={classnames({
                                                'active': activeTab === 'other',
                                                'alert': !isOtherValid
                                            })}
                                        >
                                            {i18n['creatingObjectPage.other']}
                                        </li>}
                                        {this.props.type === ObjectConst.TYPE.SELL && <li
                                            data-name='otherSell'
                                            onClick={::this.handleTabClick}
                                            className={
                                                this.state.activeTab === 'otherSell' ? 'active' : ''
                                            }
                                        >
                                            {i18n['creatingObjectPage.other']}
                                        </li>}
                                        <li
                                            data-name='photo'
                                            onClick={::this.handleTabClick}
                                            className={
                                                this.state.activeTab === 'photo' ? 'active' : ''
                                            }
                                        >
                                            {i18n['creatingObjectPage.photo']}
                                        </li>
                                        {this.props.type === ObjectConst.TYPE.RENT && <li
                                            data-name='calendar'
                                            onClick={::this.handleTabClick}
                                            className={
                                                this.state.activeTab === 'calendar' ? 'active' : ''
                                            }
                                        >
                                            {i18n['creatingObjectPage.theCalendar']}
                                        </li>}
                                        <li
                                            data-name='channelManager'
                                            onClick={::this.handleTabClick}
                                            className={
                                                this.state.activeTab === 'channelManager' ? 'active' : ''
                                            }>
                                            {i18n['creatingObjectPage.channelManager']}
                                        </li>
                                        <li
                                            data-name='channelManagerAirbnb'
                                            onClick={::this.handleTabClick}
                                            className={
                                                this.state.activeTab === 'channelManagerAirbnb' ? 'active' : ''
                                            }>
                                            Channel Manager Airbnb
                                        </li>
                                    </ul>

                                    <a
                                        href=""
                                        onClick={this.handlePublishClick}
                                        className="button lg icon check fullwidth add_save_button"
                                    >
                                    <span>
                                        {i18n['creatingObjectPage.publish']}
                                    </span>
                                    </a>
                                </div>
                                <div className="clearfix add_data">

                                    <form className="light" action="#" method="post" encType="multipart/form-data">
                                        <div id="m-tab" className="clearfix">
                                            <GeneralInformation
                                                isActive={this.state.activeTab === 'generalInformation'}
                                            />

                                            <Prices isActive={this.state.activeTab === 'prices'}/>

                                            <Address isActive={this.state.activeTab === 'address'}/>

                                            <Amenities isActive={this.state.activeTab === 'facilities'}/>

                                            <Characteristics isActive={this.state.activeTab === 'characteristics'}/>

                                            <Other isActive={this.state.activeTab === 'other'}/>

                                            <OtherSell isActive={this.state.activeTab === 'otherSell'}/>

                                            <Photo isActive={this.state.activeTab === 'photo'}/>

                                            <Calendar isActive={this.state.activeTab === 'calendar'}
                                                      propertyIdUrl={this.props.match.params.id}/>

                                            <ChannelManager isActive={this.state.activeTab === 'channelManager'}/>

                                            {propertyId !== undefined && <ChannelManagerAirbnb isActive={this.state.activeTab === 'channelManagerAirbnb'} propertyId={propertyId}/>}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ReactModal
                        className="custom-react-modal"
                        isOpen={this.state.isShowNotValidModal}
                        overlayClassName="custom-react-modal-overlay"
                    >
                        {i18n['creatingObjectPage.objectContainsErrors']}
                        <br/><br/>
                        <button onClick={::this.handleHideNotValidModal} className="btn">
                            {i18n['creatingObjectPage.close']}
                        </button>
                    </ReactModal>
                </Layout>
            )
        }
    }
}

CreateEditPropertyPage.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    currentUser: state.user.currentUser,
    userId: state.user.currentUser.userId,
    objectId: state.creatingObjectPage.createdObject.id,
    mainPhotoURL: state.creatingObjectPage.mainPhotoURL,
    type: state.creatingObjectPage.createdObject.props.type,
    images: state.creatingObjectPage.createdObject.meta.images,
    isPricesValid: state.creatingObjectPage.validation.isPricesValid,
    isAddressValid: state.creatingObjectPage.validation.isAddressValid,
    isRedirectToObjectPage: state.creatingObjectPage.isRedirectToObjectPage,
    userRepresent: state.creatingObjectPage.createdObject.meta.userRepresent,
    displayName: state.creatingObjectPage.createdObject.description.displayName,
    isGeneralInformationValid: state.creatingObjectPage.validation.isGeneralInformationValid,
    isOtherValid: state.creatingObjectPage.validation.isOtherValid,
    currency: state.creatingObjectPage.createdObject.price.currency
});

const mapDispatchToProps = {
    updateField,
    publishObject,
    stopRedirect,
    getCreatedObject,
    setRedirectToObjectPage
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateEditPropertyPage);



// WEBPACK FOOTER //
// ./src/components/CreatingProperty/CreateEditPropertyPage.js